import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineAsyncComponent } from 'vue';
import { computed } from 'vue';

const authedLayout = '';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const defaultLayout = defineAsyncComponent(() => import('@/layout/DefaultLayout.vue'))

const layout = computed(() => {
  const AuthenticationOk = false;
  if (AuthenticationOk) {
    return authedLayout;
  }

  return defaultLayout;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value)))
}
}

})